module.exports = __webpack_public_path__ + "img/snow_fall_00021.1cb0ecff.png";